import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { ApiInterceptor } from './core/services/interceptor/api.interceptor';

import { provideStore } from '@ngrx/store';
import { rootReducer } from '../store';
import { localStorageSyncReducer } from '../store/layout/layout-reducers';
import { FakeBackendInterceptor, FakeBackendProvider } from './core/helper/fake-backend';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { withEnabledBlockingInitialNavigation } from '@angular/router';
import { isDevMode } from '@angular/core';
import { provideServiceWorker } from '@angular/service-worker';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withEnabledBlockingInitialNavigation() // ✅ THE REAL FIX
    ),
    //  provideServiceWorker('ngsw-worker.js', {
    //   enabled: isDevMode(), // only in production
    //   registrationStrategy: 'registerWhenStable:30000', 
    // }),
    provideClientHydration(withEventReplay()),
    FakeBackendProvider,
    provideStore(rootReducer, { metaReducers: [localStorageSyncReducer] }),
    provideHttpClient(withFetch(), withInterceptors([ApiInterceptor])),
    
  ],
};
